export enum OffersTableAccessor {
    Date = 'date',
    Property = 'property',
    ProposedRent = 'proposedRent',
    Status = 'status',
    Actions = 'actions',
};
